import _ from 'lodash'

export const sortString = function (string) {
  var integer = parseInt(string);

  if (string == String(integer)) {
    return integer;
  } else if (!string) {
    return undefined;
  } else {
    return string.trim().toLowerCase();
  }
};

export const materialGroups = function (materials) {
  var groups = _.groupBy(materials, function (material) {
    return material.locationId + ',' + material.surface;
  });

  return _.map(groups, function (materials, key) {
    var keySplit = key.split(',');

    return {
      location: keySplit[0],
      surface: keySplit[1],
      materials: materials,
    };
  });
};
